<template>
  <div>
    <div v-if="displayNoBillingCyclesMessage && !billingCycles.length">
      No Billing Cycles found
    </div>
    <div v-for="(billingCycle, i) in billingCycles" :key="i">
      <v-row class="ma-0 pa-0">
        <v-col
          cols="12"
          class="ma-0 pa-0"
        >
          <div>{{ billingCycle.billing_cycle }}
            <hb-tooltip v-if="nationalAccount">
              <template v-slot:body>
              This setting is not editable. Please contact the National Account Manager for more information.
            </template>
          </hb-tooltip>
          </div>
          <div :class="durationPeriodColor" class="hb-font-caption pb-2">
            {{ billingCycle.start_date | formatLocalDate }}
            <span v-if="billingCycle.end_date">- {{ billingCycle.end_date | formatLocalDate }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script type="text/babel">

export default {
  name: "BillingCycleInfo",
  props: {
    billingCycles: {
      type: Array
    },
    durationPeriodColor: {
      type: String,
      required: false,
      default: "hb-text-light",
    },
    displayNoBillingCyclesMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    nationalAccount:{
      type: Boolean
    }
  },
};
</script>